module.exports = __webpack_public_path__ + "img/root0.cfaf9424.png";